<div class="row">
  <div class="col-sm-12">
    <div class="box box-solid">
      <div class="box-header with-border">
        <h3 class="box-title" translate>
          Criteria <small></small>
        </h3>
        <div class="box-tools pull-right">
          <button type="button" class="btn btn-default btn-sm" data-widget="collapse">
            <i class="fa fa-minus"></i>
          </button>
        </div>
      </div>
      <!-- /.box-header -->
      <div class="box-body">
        <div class="form-horizontal">
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group">
                <label class="col-lg-4 control-label"> <b translate>รหัส</b></label>

                <div class="col-lg-8">
                  <input type="text" id="txtID" class="form-control" />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group">
                <label class="col-lg-4 control-label"> <b translate>ตำแหน่ง/สาขาวิชา</b></label>

                <div class="col-lg-8">
                  <input type="text" id="txtDesc" class="form-control" />
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label class="col-lg-4 control-label"> <b translate>สถานะ</b></label>

                <div class="col-lg-8">
                  <select id="ddlStatus" class="form-control">
                    <option translate value="-99">ทั้งหมด</option>
                    <option translate value="1">ใช้งาน</option>
                    <option translate value="0">ไม่ใช้งาน</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="box-footer clearfix">
        <div>
          <button type="button" class="btn btn-primary pull-right" (click)="Search()">
            <i class="fa  fa-search"></i>&nbsp;<span translate>ค้นหา</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-sm-12">
    <div class="box box-solid">
      <div class="box-header with-border">
        <h3 translate class="box-title">
          ข้อมูล <small></small>
        </h3>
        <div class="box-tools pull-right">
          <button type="button" class="btn btn-default btn-sm" data-widget="collapse">
            <i class="fa fa-minus"></i>
          </button>
        </div>
      </div>
      <!-- /.box-header -->
      <div class="box-body">
        <div class="box-body">
          <button type="button" class="btn btn-default" (click)="Add()">
            <i class="glyphicon glyphicon-plus colorgreen"></i>&nbsp;<span translate>เพิ่ม</span>
          </button>
          <button type="button" class="btn btn-default" (click)="Edit()">
            <i class="fa fa-edit coloryellow"></i>&nbsp;<span translate>แก้ไข</span>
          </button>
        </div>

        <!-- /.box-header -->
        <div class="box-body" id="divData">
          <table id="tData" class="table table-bordered  table-hover">
            <thead>
              <tr>
                <th width="15%" translate>รหัส</th>
                <th width="25%" translate>ตำแหน่ง/สาขาวิชา</th>
                <th width="10%" translate>สถานะ</th>
                <th width="10%" translate>วันที่แก้ไข</th>
                <th width="15%" translate>ผู้แก้ไข</th>
                <th width="10%" translate>ลบ</th>
              </tr>
            </thead>
            <tbody>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container">
  <div class="modal fade" id="dlgData" role="dialog">
    <div class="modal-dialog" style="width: 65%;">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" id="btnCloseDlg" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">
            <span translate>ตำแหน่ง/สาขาวิชา</span>
          </h4>
        </div>
        <div class="modal-body">
          <input type="text" id="txtMode" class="form-control" style="display: none;" />
          <div class="form-horizontal">
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group">
                  <label class="col-lg-4 control-label required"> <b translate>รหัส</b></label>

                  <div class="col-lg-8">
                    <input type="text" id="txtDlgID" required class="form-control" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group">
                  <label class="col-lg-4 control-label required"> <b translate>ตำแหน่ง/สาขาวิชา</b></label>

                  <div class="col-lg-8">
                    <input type="text" id="txtDlgDesc" required class="form-control" />
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label class="col-lg-4 control-label required"> <b translate>สถานะ</b></label>

                  <div class="col-lg-8">
                    <select id="ddlDlgStatus" class="form-control">
                      <option translate value="1">ใช้งาน</option>
                      <option translate value="0">ไม่ใช้งาน</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">ยกเลิก</button>
          <button type="button" class="btn btn-primary " (click)="Save()">บันทึก</button>
        </div>

      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/member/position/position.component.html